const urls = {
    LOGIN_URL: "authentication/login",
    SECURITY_USER: "security/user",
    SECURITY_ROLE: 'security/role',
    PASSWORD_RESET: "security/password-reset",
    CHECK_PASSWORD_CHANGE: "security/check-password-change",
    PASSWORD_CHANGE_EXPIRED: 'security/password-change-expired',
    PASSWORD_CHANGE: "security/password-change",
    APPLICATION_MENU: "security/application-menu",
    SELF_RESET_PASSWORD: "security/self-reset-password",
    COMPLETE_SELF_RESET_PASSWORD: "security/complete-self-reset-password",
    UI_PERMISSIONS: 'security/user-roles-get-attribute-value',
    CLONE_ROLES: 'security/user-roles-clone'
}

import genericService from '../genericService';

export default {
    async login (body, callback){
        await genericService.loginPost(urls.LOGIN_URL, body).then(callback);
    },
    async passwordReset(body, callback){
        await genericService.post(urls.PASSWORD_RESET, body).then(callback);
    },
    async checkPasswordChange(body, callback){
        await genericService.get(urls.CHECK_PASSWORD_CHANGE, body).then(callback);
    },
    async changePassword(body, callback){
        await genericService.post(urls.PASSWORD_CHANGE, body).then(callback);
    },
    async getApplicationMenu(body, callback){
        await genericService.get(urls.APPLICATION_MENU, body).then(callback);
    },
    async selfResetPassword(body, callback){
        await genericService.publicPost(urls.SELF_RESET_PASSWORD, body).then(callback);
    } ,
    async completeSelfResetPassword(body, callback){
        await genericService.publicPost(urls.COMPLETE_SELF_RESET_PASSWORD, body).then(callback);
    },
    async getUiPermissions(body, callback){
        await genericService.get(urls.UI_PERMISSIONS, body).then(callback);
    },
    async getRoles(body, callback){
        await genericService.get(urls.SECURITY_ROLE, body).then(callback);
    },
    async changePasswordExpired(body, callback){
        await genericService.publicPost(urls.PASSWORD_CHANGE_EXPIRED, body).then(callback);
    },
    async cloneRoles(body, callback){
        await genericService.post(urls.CLONE_ROLES, body).then(callback);
    },
}